import { AfterViewInit, Component, ViewChildren } from '@angular/core';
import { Ballot } from '../ballot/backend-types';
import { BallotListService } from './ballot-list.service';
import { Router } from '@angular/router';
import { ballotRoute, petitionRoute } from '../route-names';
import { ApiAboutService } from '../Services/api-about.service';

@Component({
    selector: 'app-ballot-list',
    templateUrl: './ballot-list.component.html',
    styleUrls: ['./ballot-list.component.scss'],
    standalone: false
})
export class BallotListComponent implements AfterViewInit {

  ballots: Ballot[];
  checkedIndex: number | undefined
  ballotsCount: number 
  @ViewChildren("row") rows: any;
  routeName = ""
  focusStates: boolean[] = [];


  constructor(
    private readonly listService: BallotListService,
    private readonly router: Router,
    readonly aboutService: ApiAboutService
  ) {
    this.ballots = listService.getBallots()
    this.ballotsCount = this.ballots.length
  }

  ngAfterViewInit() {
    this.routeName = this.router.url
    setTimeout(()=>{  
      this.resetFocus()
    }, 100);
  }

  resetFocus() {
    let focusField = document.getElementById('accessibility-button')
    let focusFieldMobile = document.getElementById('accessibility-button-mobile')
  
    if (focusField) {
      focusField.focus()
    }

    if (focusFieldMobile) {
     focusFieldMobile.focus()
    }
  }

  selectedBallot(index: number): void {
    this.listService.setBallotService(index)
    if(this.ballots[index].eventType?.toLowerCase() === 'petition') {
      this.router.navigate(petitionRoute)
    } else {
      this.router.navigate(ballotRoute);
    }
  }

  selectAnswer(number: number){
    this.checkedIndex = number;
  }  

  next(){
    if(this.checkedIndex !== undefined) {
      this.selectedBallot(this.checkedIndex);
    }
  }
  onFocus(index: number) {
    this.focusStates[index] = true;
  }
  
  onBlur(index: number) {
    this.focusStates[index] = false;
  }
  
}
